import { isBuiltInStyleName } from "./word-builtins.js";

const UNRECOGNISED = /^Unrecognised (paragraph|run) style: '(.*)' \(Style ID: [^)]*\)$/s;

function tally(map, key, create) {
  const item = map.get(key) ?? create();
  item.count += 1;
  map.set(key, item);
}

export function classifyMessages(messages) {
  const custom = new Map();
  const builtin = new Map();
  const other = new Map();
  for (const { type, message } of messages) {
    const match = UNRECOGNISED.exec(message);
    if (match) {
      const [, styleType, name] = match;
      const target = isBuiltInStyleName(name) ? builtin : custom;
      tally(target, `${styleType}|${name}`, () => ({ type: styleType, name, count: 0 }));
    } else {
      tally(other, message, () => ({ type, message, count: 0 }));
    }
  }
  return { customStyles: [...custom.values()], builtinStyles: [...builtin.values()], other: [...other.values()] };
}
